<template>
  <div class="homecare-container">
    <div class="homecare-container_ cen">
      <Breadcrumb>
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ path: '/homecare/index', query: { cid: fid } }">居家养老</BreadcrumbItem>
        <BreadcrumbItem>{{currentClassName.classname}}</BreadcrumbItem>
      </Breadcrumb>
      <div class="inside-main">
        <div class="homecare-list">
          <div class="homecare-li" v-for="item in carelist" :key="item.id">
            <router-link :to="{ path: '/homecare/detail', query: { cid: item.classid, id: item.id } }" class="homecare-li_">
              <div class="homecare-li-img">
                <div :style="'backgroundImage:url(' + domainNameH5 + '/' + item.picurl + ')'"></div>
              </div>
              <div class="homecare-li-title">{{item.title}}</div>
            </router-link>
          </div>
          <div class="list-page" v-if="totalsPage>1">
            <Page
              :current="page"
              :total="totals"
              @on-change="changePage"
              :page-size="9"
              prev-text="上一页"
              next-text="下一页"
            />
            <div class="list-page-total">共{{totalsPage}}页</div>
            <div class="list-page-jump">
              到第 <Input v-model="jumpPage" /> 页
            </div>
            <div class="list-page-btn" @click="jumpPageDeal">确定</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">{{fname.classname}}</div>
            <div class="enname">{{fname.classname_en}}</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li" v-for="item in getsort" :key="item.id" :class="[ item.id === cid ? 'active' : '']">
              <router-link :to="{ path: '/homecare', query: { cid: item.id } }" class="left-nav-link">
                <div class="chname">{{item.classname}}</div>
                <div class="enname">{{item.classname_en}}</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
    <apply-member></apply-member>
  </div>
</template>

<script>
import { validateInteger } from '../../assets/js/validate.js'
import { getHeaderData, getHomeCareBasicData, getHomeCareListData } from '../../api/getData.js'
import ApplyMember from '../../components/applyMember'
export default {
  name: 'homeCare',
  components: {
    ApplyMember
  },
  data () {
    return {
      headerInfo: {},
      fid: '',
      cid: '',
      page: 1,
      jumpPage: '',
      totals: 0,
      totalsPage: 1,
      currentClassName: '',
      fname: {},
      getsort: [],
      carelist: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  watch: {
    '$route': function () {
      this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
      this.getHeaderInfo()
      this.getHomeCareListInfo()
    }
  },
  created () {
    this.cid = this.$route.query.cid === undefined ? '' : this.$route.query.cid
    this.getHomeCareBasicInfo(this.cid)
    this.getHeaderInfo()
    this.getHomeCareListInfo()
  },
  methods: {
    async getHeaderInfo () {
      let postData = { cid: this.cid }
      let header = await getHeaderData(postData)
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'homecare', activeSendMenu: this.cid }).then(() => {}).catch(() => {})
    },
    async getHomeCareBasicInfo (cid) {
      let postData = {}
      if (cid !== '') {
        postData.cid = cid
      }
      let result = await getHomeCareBasicData(postData)
      this.fid = result.fid
      this.cid = result.cid
      this.fname = result.fname
      this.getsort = result.getsort
      this.getHeaderInfo()
    },
    async getHomeCareListInfo () {
      let postData = {}
      if (this.cid !== '') {
        postData.cid = this.cid
      }
      postData.p = this.page
      let result = await getHomeCareListData(postData)
      this.totals = result.totalnum
      this.totalsPage = Math.ceil(result.totalnum / 9)
      this.currentClassName = result.cname
      this.carelist = result.carelist
    },
    changePage (page) {
      this.page = page
      this.getHomeCareListInfo()
    },
    jumpPageDeal () {
      if (!validateInteger(this.jumpPage)) {
        this.message('请输入正整数')
        return false
      }
      if (this.jumpPage > this.totalsPage) {
        this.message('页码不能大于' + this.totalsPage)
        return false
      }
      this.page = parseFloat(this.jumpPage)
      this.getHomeCareListInfo()
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .inside-main{
    padding-bottom: 230px;
  }
  .homecare-list{
    width: 76.9%;
    .homecare-li{
      float: left;
      width: 33.33%;
      margin-top: 60px;
      padding-left: 45px;
      &:nth-child(1),&:nth-child(2),&:nth-child(3){
        margin-top: 0;
      }
      .homecare-li_{
        .homecare-li-img{
          position: relative;
          padding-top: 75%;
          background-color: #ffffff;
          background-image: url("../../assets/images/pic04.png");
          background-position: center;
          background-repeat: no-repeat;
          overflow: hidden;
          div{
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            transition: all 0.5s ease 0s;
          }
        }
        .homecare-li-title{
          height: 80px;
          padding: 22px 20px;
          background-color: #eeeeee;
          box-shadow: 0px 3px 6px 0px rgba(52, 47, 144, 0.2);
          font-size: 24px;
          line-height: 36px;
          color: #eb6420;
          transition: all 0.5s ease 0s;
        }
        &:hover{
          .homecare-li-img{
            div{
              transform: scale(1.05);
            }
          }
          .homecare-li-title{
            color: #ffffff;
            background-color: #eb6420;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1580px){
    .inside-main{
      padding-bottom: 195px;
    }
  }
  @media screen and (max-width: 1480px){
    .homecare-list{
      .homecare-li{
        padding-left: 25px;
        margin-top: 30px;
      }
    }
  }
  @media screen and (max-width: 1200px){
    .inside-main{
      padding-bottom: 80px;
    }
    .homecare-list {
      width: 100%;
      margin-bottom: 20px;
      overflow: hidden;
      .homecare-li{
        float: none;
        width: 100%;
        margin-top: 15px;
        padding-left: 0;
        &:nth-child(2),&:nth-child(3){
          margin-top: 15px;
        }
        .homecare-li_{
          .homecare-li-img{
            background-size: 100px auto;
          }
          .homecare-li-title{
            height: 40px;
            padding: 11px 10px;
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }
  }
</style>
